export function getDisplayDocumentId(documentId: string) {
  return documentId.startsWith('new-') ? 'New-doc' : documentId
}
